import { AutoCompleteComponent } from "@syncfusion/ej2-react-dropdowns";
import React, { Component } from "react";
import { Button, Spinner } from "react-bootstrap";
import moment from "moment-jalaali";
// import DatePicker from 'react-datepicker2';
import ToggleButton from "../components/ToggleButton";
import NumberFormat from "react-number-format";
import { Query } from "@syncfusion/ej2-data";
import { Redirect } from "react-router-dom";
import dateicon from "../assets/dateicon.png";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";

import DatePicker, { DateObject } from "react-multi-date-picker";
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";

export default class BuySell extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lowestprice: null,
      highestprice: null,
      dateValue: moment().format("jYYYY/jMM/jDD"),
      SellValue: false,
      BuyValue: true,
      chashchange: "",
      costchange: "",
      quantitychange: "",
      selectedSymbol: null,
      selectedSymbol1: null,
      selectedBasket: "",
      selectedBroker: "",
      basketValue: "",
      brokerValue: "",
      Redirect: false,
      dateErrorText: "",
      symbolErrorText: "",
      quantityErrorText: "",
      cashErrorText: "",
      costErrorText: "",
      basketErrorText: "",
      brokerErrorText: "",
      dateFalse: false,
      symbolFalse: false,
      quantityFalse: false,
      cashFalse: false,
      costFalse: false,
      basketFalse: false,
      brokerFalse: false,
      buttonTitle: "خرید",
      maxDateStart: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      options: [],
      isLoading: false,
      currenttseid: "",
      buttonDisabled: false,
      currentSymboleSelected: "",
      isEdit: null,
      hasCost: false,
    };

    this.fields = { value: "full_name" };
    this.fields1 = { value: "lable" };
    this.fields2 = { value: "full_name" };

    this.query = new Query().where("type_code", "notequal", 7);

    this.dateChange = this.dateChange.bind(this);
    this.convertDate = this.convertDate.bind(this);
    this.getPriceInterval = this.getPriceInterval.bind(this);

    this.cashchange = this.cashchange.bind(this);
    // this.costchange = this.costchange.bind(this);
    this.quantitychange = this.quantitychange.bind(this);
    this.calculateCost = this.calculateCost.bind(this);
    this.getSymbolId = this.getSymbolId.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.getSymbol = this.getSymbol.bind(this);

    this.datepickerr = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.userBasketsData !== this.props.userBasketsData) {
      if (this.props.userBasketsData.length > 1) {
        this.acBaskets.readonly = false;
      } else {
        this.acBaskets.readonly = true;
      }
    }

    if (prevProps.userBrokersData !== this.props.userBrokersData) {
      if (this.props.userBrokersData.length > 1) {
        this.acBrokers.readonly = false;
      } else {
        this.acBrokers.readonly = true;
      }
    }
  }

  componentDidMount() {
    if (
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length < 2
    ) {
      this.setBrokerValue(this.props.userBrokersData[0].full_name, true);
    }

    if (this.props.userBasketsData.length < 2) {
      this.setBasketValue(this.props.userBasketsData[0].lable, true);
    }
  }

  convertDate(date) {
    let timee = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    let year = "";
    let month = "";
    let day = "";
    timee.forEach((element) => {
      if (element.type === "year") {
        year = element.value;
      } else if (element.type === "month") {
        month = element.value;
      } else if (element.type === "day") {
        day = element.value;
      }
    });
    let formatedDate = year + "/" + month + "/" + day;
    let pdate = moment(formatedDate, "YYYY/MM/DD").format("jYYYY-jMM-jDD");
    return pdate;
  }

  getSymbol(query, id) {
    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: query,
      type: "all",
    };
    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ options: resultt.result }, () => {
            resultt.result.forEach((element) => {
              console.log("element.id: ", element.id);
              console.log("id: ", id);
              if (element.id === id) {
                let s = [];
                s.push(element);
                this.setState(
                  { selectedSymbol: element, selectedSymbol1: s },
                  () => {
                    this.getPriceInterval(this.state.selectedSymbol);
                  }
                );
              }
            });
            this.setState({ isLoading: false });
          });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  SubmitFrom() {
    try {
      let selectbasket = this.acBaskets.value;
      let selectbroker = this.acBrokers.value;
      // let date=this.convertDate(this.state.dateValue);

      let date = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );

      let symbolid;
      if (this.state.selectedSymbol !== null)
        symbolid = this.state.selectedSymbol.id;
      let brokerid;
      let basketid;
      let type;
      // this.props.symbolsData.forEach(function(entry) {
      //     if (entry.full_name===selectsymbol){
      //         symbolid=entry.id;
      //     }
      // });

      this.props.userBasketsData.forEach(function (entry) {
        if (entry.lable === selectbasket) {
          basketid = entry.id;
        }
      });

      this.props.userBrokersData.forEach(function (entry) {
        if (entry.full_name === selectbroker) {
          brokerid = entry.id;
        }
      });

      if (!this.state.SellValue) {
        type = "buy";
      } else {
        type = "sell";
      }

      let cash = this.state.chashchange
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "");
      let quantity = this.state.quantitychange
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "");

      if (this.state.dateValue === "") {
        this.setState({ dateFalse: true, dateErrorText: "تاریخ نامعتبر است" });
        return;
      } else {
        this.setState({ dateFalse: false, dateErrorText: "" });
      }
      if (this.state.selectedSymbol === null) {
        document.querySelectorAll(".rbt-input-main")[0].style.border =
          "1px solid var(--red1)";
        this.setState({
          symbolFalse: true,
          symbolErrorText: "نام نماد باید وارد شود",
        });
        return;
      } else {
        document.querySelectorAll(".rbt-input-main")[0].style.border =
          "1px solid #ced4da";
        this.setState({ symbolFalse: false, symbolErrorText: "" });
      }
      if (quantity === "") {
        this.setState({
          quantityFalse: true,
          quantityErrorText: "تعداد نامعتبر است",
        });
        return;
      } else if (Number(quantity) < 1) {
        this.setState({
          quantityFalse: true,
          quantityErrorText: "تعداد نمی تواند صفر باشد",
        });
        return;
      } else {
        this.setState({ quantityFalse: false, quantityErrorText: "" });
      }
      if (cash === "") {
        this.setState({ cashFalse: true, cashErrorText: "مبلغ نامعتبر است" });
        return;
      } else if (Number(cash) < 1) {
        this.setState({
          cashFalse: true,
          cashErrorText: "مبلغ نمی تواند صفر باشد",
        });
        return;
      } else {
        this.setState({ cashFalse: false, cashErrorText: "" });
      }

      if (
        this.acBaskets.value === null ||
        this.acBaskets.value === "" ||
        basketid === undefined
      ) {
        this.setState({
          basketFalse: true,
          basketErrorText: "نام سبد نامعتبر است",
        });
        return;
      } else {
        this.setState({ basketFalse: false, basketErrorText: "" });
      }
      if (
        this.acBrokers.value === null ||
        this.acBrokers.value === "" ||
        brokerid === undefined
      ) {
        this.setState({
          brokerFalse: true,
          brokerErrorText: "نام کارگزاری نامعتبر است",
        });
        return;
      } else {
        this.setState({ brokerFalse: false, brokerErrorText: "" });
      }

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        cash_change: cash,
        broker_id: brokerid,
        basket_id: basketid,
        dscr: null,
        date: date,
        symbol_id: symbolid,
        symbol_type: this.state.selectedSymbol.type_code,
        quantity_change: quantity,
        type: type,
      };

      if (this.state.isEdit) {
        this.editAction(data, brokerid, basketid);
        return;
      }

      this.setState({ buttonDisabled: true });
      fetch("/api/transaction", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.props.onRefresh();
            this.resetForm();

            toast.success(
              "عملیات " + this.state.buttonTitle + " با موفقیت ثبت گردید",
              {
                position: toast.POSITION.BOTTOM_LEFT,
                hideProgressBar: true,
                autoClose: 8000,
                toastClassName: "toast",
              }
            );
          } else if (resultt.status === 401) {
            this.setState({ Redirect: true });
          } else {
            toast.error(resultt.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          }
          this.setState({ buttonDisabled: false });
        });
    } catch (error) {
      this.setState({ buttonDisabled: false });
    }
  }

  onBuyClick() {
    this.setState({ BuyValue: true, SellValue: false, buttonTitle: "خرید" });
  }

  onSellClick() {
    this.setState({ BuyValue: false, SellValue: true, buttonTitle: "فروش" });
  }

  acSymbolChange(item) {
    try {
      if (item.length < 1) {
        this.setState({ selectedSymbol: null, selectedSymbol1: null });
        return;
      }
      let s = [];
      s.push(item[0]);
      this.setState({ selectedSymbol: item[0], selectedSymbol1: s }, () => {
        if (this.state.selectedSymbol !== null && this.state.dateValue !== "") {
          this.getPriceInterval(this.state.selectedSymbol);
        }
      });
    } catch (error) {}
  }

  acBasketChange() {
    this.setState({ selectedBasket: this.acBaskets.value });
  }

  acBrokerChange() {
    this.setState({ selectedBroker: this.acBrokers.value });
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));

    if (value === this.state.dateValue) return;

    // this.setState({ dateValue: value})
    this.setState({ dateValue: value }, () => {
      if (this.state.selectedSymbol !== null && this.state.dateValue !== "") {
        this.getPriceInterval(this.state.selectedSymbol);
      }
    });
  }

  // dateChange(dateValue){
  //     if (dateValue===this.state.dateValue) return
  //     this.setState({dateValue: dateValue},
  //     ()=>{
  //         if (this.state.selectedSymbol!==null && this.state.dateValue!==''){
  //         this.getPriceInterval(this.state.selectedSymbol);
  //     }
  //     });
  // }

  getPriceInterval(value) {
    try {
      // let date=this.convertDate(this.state.dateValue);

      let date = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        date: date,
        symbol_id: value.id,
      };

      fetch("/api/priceInterval", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            if (resultt.result[0].low !== null) {
              this.setState({
                hasCost: true,
                lowestprice: resultt.result[0].low,
                highestprice: resultt.result[0].high,
              });
            } else {
              this.setState({
                lowestprice: 0,
                highestprice: 0,
                hasCost: false,
              });
            }
          } else if (resultt.status === 401) {
            this.setState({ Redirect: true });
          }
        })
        .catch((err) => {});
    } catch (error) {}
  }

  cashchange(event) {
    this.setState({ chashchange: event.target.value });

    this.calculateCost(event.target.value, this.state.quantitychange);
  }

  quantitychange(event) {
    this.setState({ quantitychange: event.target.value });
    this.calculateCost(this.state.chashchange, event.target.value);
  }

  calculateCost(cash, quantity) {
    try {
      cash = cash
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "")
        .trim();

      quantity = quantity
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "")
        .trim();
      if (
        quantity !== null &&
        cash !== null &&
        quantity !== "" &&
        cash !== "" &&
        quantity > 0 &&
        cash > 0
      ) {
        let aa = Math.floor(cash / quantity);
        this.setState({ costchange: aa });
      } else {
        this.setState({ costchange: "" });
      }
    } catch (error) {
      this.setState({ costchange: "" });
    }
  }

  setBasketValue(name, readonly) {
    this.acBaskets.value = name;
    this.acBaskets.readonly = readonly;
  }

  setBrokerValue(name, readonly) {
    this.acBrokers.value = name;
    this.acBrokers.readonly = readonly;
    // alert(name)
  }

  async getSymbolId(symbol) {
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: symbol,
      isRight: false,
    };

    await fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ currenttseid: resultt.result[0].tse_id });
        } else {
          this.setState({ currenttseid: "" });
        }
      });
  }

  searchSymbol(query) {
    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: query,
      type: "all",
    };

    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ options: resultt.result, isLoading: false });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  itemTemplate(data) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div>{data.broker_name}</div>
        {data.lable !== null &&
          data.lable !== "" &&
          data.lable !== undefined && (
            <div style={{ fontSize: "12px", color: "var(--gray1)" }}>
              {data.lable}
            </div>
          )}
      </div>
    );
  }

  resetForm() {
    // if (this.props.isPopup){
    //     this.props.cancelForm();
    //     return;
    // }
    this.setState({
      hasCost: false,
      chashchange: "",
      quantitychange: "",
      lowestprice: null,
      highestprice: null,
      costchange: "",
      isEdit: null,
      selectedSymbol: null,
      selectedSymbol1: null,
      dateErrorText: "",
      symbolErrorText: "",
      quantityErrorText: "",
      cashErrorText: "",
      costErrorText: "",
      basketErrorText: "",
      brokerErrorText: "",
      dateFalse: false,
      symbolFalse: false,
      quantityFalse: false,
      cashFalse: false,
      costFalse: false,
      basketFalse: false,
      brokerFalse: false,
    });
    this.acSymbol.clear();
    document.querySelectorAll(".rbt-input-main")[0].style.border =
      "1px solid #ced4da";
    if (
      this.props.selectedPortfolioId === 0 &&
      this.props.userBasketsData.length > 1
    ) {
      this.acBaskets.value = "";
    }
    if (
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length > 1
    ) {
      this.acBrokers.value = "";
    }
  }

  editFrom(data) {
    if (data.type_id === 4) {
      this.setState({ BuyValue: true, SellValue: false, buttonTitle: "خرید" });
    } else {
      this.setState({ BuyValue: false, SellValue: true, buttonTitle: "فروش" });
    }

    this.setState(
      {
        chashchange: Math.abs(data.cash_change),
        quantitychange: Math.abs(data.quantity),
        dateValue: moment(data.date, "jYYYY-jMM-jDD").format("jYYYY/jMM/jDD"),
      },
      () => {
        this.calculateCost(this.state.chashchange, this.state.quantitychange);
      }
    );

    if (this.props.userBasketsData.length > 1) {
      this.acBaskets.value = data.basket;
    }
    if (this.props.userBrokersData.length > 1) {
      if (data.lable !== null && data.lable !== "") {
        this.acBrokers.value = data.broker + " (" + data.lable + ")";
      } else {
        this.acBrokers.value = data.broker;
      }
    }
    // console.log(data);
    this.getSymbol(data.symbol, data.symbol_id);
    this.setState({ isEdit: data });
  }

  editAction(body, brokerid, basketid) {
    let data = body;

    let d = [];
    if (this.state.isEdit.child === undefined) {
      d.push(this.state.isEdit);
    } else {
      this.state.isEdit.child.forEach((element) => {
        d.push(element);
      });
    }
    data.list = d;
    this.setState({ buttonDisabled: true });
    fetch("/api/editTransaction", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.props.onRefresh();

          this.resetForm();
          toast.success("سند با موفقیت ویرایش شد", {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        } else if (resultt.status === 401) {
          this.setState({ Redirect: true });
        } else {
          toast.error(resultt.message, {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
        this.setState({ buttonDisabled: false });
      })
      .catch((err) => {
        this.setState({ buttonDisabled: false });
      });
  }

  setSymbolFromGrid(symbol, symbolid) {
    this.getSymbol(symbol, symbolid);
  }

  cancelForm() {
    if (this.props.isPopup) {
      this.props.cancelForm();
      return;
    } else {
      this.resetForm();
    }
  }

  render() {
    if (this.state.Redirect) return <Redirect to="/Login" />;
    return (
      <div className="contentStyle">
        <div id="componentsParent">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: "30px",
            }}
          >
            <ToggleButton
              selected={this.state.BuyValue}
              color="var(--green1)"
              text="خرید"
              onToggleClick={this.onBuyClick.bind(this)}
            />
            <ToggleButton
              selected={this.state.SellValue}
              color="var(--red1)"
              text="فروش"
              onToggleClick={this.onSellClick.bind(this)}
            />
          </div>

          <div style={{ width: "100%" }}>
            {/* <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRedDate":"form-control inputStyleFormDate"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                        /> */}

            <div className="InputWithIcon" style={{ direction: "ltr" }}>
              <div className="inputImageDiv">
                <img src={dateicon} className="inputImage" alt="date" />
              </div>
              {/* <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRed":"form-control inputStyleForm"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                            /> */}
              <DatePicker
                ref={this.datepickerr}
                value={this.state.dateValue}
                inputClass={
                  this.state.dateFalse
                    ? "form-control inputStyleRed"
                    : "form-control inputStyleForm"
                }
                calendar="persian"
                locale="fa"
                weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                format="YYYY/MM/DD"
                animation
                className={this.props.isPopup ? "rmdp-mobile bluee" : "bluee"}
                onChange={(valuee) => this.dateChange(valuee)}
                maxDate={this.state.maxDateStart}
                editable={false}
                inputMode="none"
                fixMainPosition={true}
                fixRelativePosition={true}
                placeholder="تاریخ"
              />
            </div>
          </div>
          <div className="errorMessage1">{this.state.dateErrorText}</div>

          <AsyncTypeahead
            id="symbolAuto1"
            searchText="در حال جستجو..."
            promptText="لطفاً نام نماد مورد نظر را تایپ کنید"
            paginationText="نمایش موارد بیشتر ..."
            useCache={true}
            ref={(scope) => (this.acSymbol = scope)}
            isLoading={this.state.isLoading}
            labelKey="full_name"
            minLength={2}
            onSearch={this.searchSymbol.bind(this)}
            onInputChange={(text) => {
              if (text === "")
                this.setState({
                  selectedSymbol: null,
                  selectedSymbol1: null,
                  lowestprice: null,
                  highestprice: null,
                });
            }}
            options={this.state.options}
            placeholder="نماد"
            delay={100}
            emptyLabel="موردی یافت نشد"
            flip={true}
            clearButton={true}
            onChange={this.acSymbolChange.bind(this)}
            selected={this.state.selectedSymbol1}
          />
          <div className="errorMessage1">{this.state.symbolErrorText}</div>

          <NumberFormat
            placeholder="تعداد"
            className={
              this.state.quantityFalse
                ? "form-control inputStyleRed"
                : "form-control inputStyleForm"
            }
            displayType={"input"}
            thousandSeparator={true}
            onChange={this.quantitychange}
            value={this.state.quantitychange}
          />
          <div className="errorMessage1">{this.state.quantityErrorText}</div>

          <NumberFormat
            placeholder="مبلغ کل معامله"
            className={
              this.state.cashFalse
                ? "form-control inputStyleRed"
                : "form-control inputStyleForm"
            }
            displayType={"input"}
            thousandSeparator={true}
            suffix={" ریال"}
            onChange={this.cashchange}
            value={this.state.chashchange}
          />
          <div className="errorMessage1">{this.state.cashErrorText}</div>

          {/* <NumberFormat 
                    placeholder="بهای تمام شده"
                    className={this.state.costFalse ? "form-control inputStyleRed":"form-control inputStyleForm"}
                    displayType={'input'} 
                    readonly
                    thousandSeparator={true} 
                    suffix={' ریال'}
                    onChange={this.costchange}
                    value={this.state.costchange}  />
                    <div className="errorMessage1">{this.state.costErrorText}</div> */}

          {/* <AutoCompleteComponent query={this.query} className={this.state.symbolFalse ? "inputStyleRed":"inputStyleForm"} ref={(scope) => this.acSymbol = scope} change={this.acSymbolChange.bind(this)} enableRtl='true' noRecordsTemplate="موردی یافت نشد" allowCustom={false} filterType="Contains" popupHeight="800px" dataSource={this.props.symbolsData} fields={this.fields} placeholder="نماد" autofill={true} /> */}

          {/* {!this.state.isEdit && <div>usdidus</div>} */}
          {this.state.costchange !== "" && (
            <div
              style={{
                width: "100%",
                color: "var(--gray1)",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                fontSize: "10px",
                direction: "rtl",
                marginBottom: "15px",
                backgroundColor: "white",
                borderRadius: "5px",
                height: "30px",
                border: "1px solid var(--gray2)",
                alignItems: "center",
                padding: "0px 10px",
                paddingTop: "2px",
              }}
            >
              <div>بهای تمام شده هر سهم:</div>{" "}
              <NumberFormat
                value={this.state.costchange}
                displayType={"text"}
                thousandSeparator={true}
                suffix={" ریال"}
              />
            </div>
          )}

          {this.state.hasCost && this.state.lowestprice !== null && (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row-reverse",
                justifyContent: "space-between",
                fontSize: "10px",
                direction: "rtl",
                marginBottom: "15px",
              }}
            >
              <div
                style={{
                  color: "var(--danger)",
                  display: "flex",
                  flexDirection: "row",
                  backgroundColor: "white",
                  borderRadius: "5px",
                  width: "49%",
                  height: "30px",
                  border: "1px solid var(--gray2)",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0px 10px",
                  paddingTop: "2px",
                }}
              >
                <div>کمترین: </div>
                <NumberFormat
                  value={this.state.lowestprice}
                  displayType={"text"}
                  thousandSeparator={true}
                  suffix={" ریال"}
                />
              </div>
              <div
                style={{
                  color: "var(--green1)",
                  display: "flex",
                  flexDirection: "row",
                  backgroundColor: "white",
                  borderRadius: "5px",
                  width: "49%",
                  height: "30px",
                  border: "1px solid var(--gray2)",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0px 10px",
                  paddingTop: "2px",
                }}
              >
                <div>بیشترین:</div>{" "}
                <NumberFormat
                  value={this.state.highestprice}
                  displayType={"text"}
                  thousandSeparator={true}
                  suffix={" ریال"}
                />
              </div>
            </div>
          )}

          {!this.state.hasCost && this.state.lowestprice !== null && (
            <div
              style={{
                color: "var(--danger)",
                width: "100%",
                display: "flex",
                flexDirection: "row-reverse",
                justifyContent: "flex-end",
                fontSize: "10px",
                direction: "rtl",
                marginBottom: "15px",
                borderRadius: "5px",
                height: "30px",
                border: "1px solid var(--gray2)",
                alignItems: "center",
                padding: "0px 10px",
              }}
            >
              <div>در تاریخ تعیین شده معامله برای نماد مورد نظر انجام نشده</div>
            </div>
          )}

          <div style={{ display: "none" }} />
          {/* {!this.state.isEdit && <div>usdidus</div>} */}

          {/* {!this.state.isEdit && <div>usdidus</div>} */}
          <AutoCompleteComponent
            showPopupButton={true}
            className={
              this.state.basketFalse ? "inputStyleRed" : "inputStyleForm"
            }
            ref={(scope) => (this.acBaskets = scope)}
            filterType="Contains"
            enableRtl="true"
            noRecordsTemplate="موردی یافت نشد"
            popupHeight="850px"
            dataSource={this.props.userBasketsData}
            fields={this.fields1}
            placeholder="سبد"
            autofill={true}
          />
          <div className="errorMessage1">{this.state.basketErrorText}</div>

          <AutoCompleteComponent
            itemTemplate={this.itemTemplate}
            showPopupButton={true}
            className={
              this.state.brokerFalse ? "inputStyleRed" : "inputStyleForm"
            }
            ref={(scope) => (this.acBrokers = scope)}
            filterType="Contains"
            enableRtl="true"
            noRecordsTemplate="موردی یافت نشد"
            popupHeight="850px"
            dataSource={this.props.userBrokersData}
            fields={this.fields2}
            placeholder="کارگزاری"
            autofill={true}
          />
          <div className="errorMessage1">{this.state.brokerErrorText}</div>

          {/* <Button variant="secondary" style={{width:'50%',fontSize:'13px',marginTop:'20px',height:'30px'}} onClick={this.SubmitFrom.bind(this)}>ثبت&nbsp;{this.state.buttonTitle}</Button> */}
          {!this.state.isEdit && !this.props.isPopup && (
            <Button
              variant="secondary"
              className="formButtonStyle"
              disabled={this.state.buttonDisabled}
              onClick={this.SubmitFrom.bind(this)}
            >
              {this.state.buttonDisabled && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.buttonDisabled && (
                <div>ثبت&nbsp;{this.state.buttonTitle}</div>
              )}
            </Button>
          )}
          {/* {!this.state.isEdit && <Button variant="secondary" className="formButtonStyle" disabled={this.state.buttonDisabled} onClick={this.SubmitFrom.bind(this)}>{this.state.buttonDisabled && <Spinner className="spinnerStyle" animation="border" />}{!this.state.buttonDisabled && <div>ثبت&nbsp;{this.state.buttonTitle}</div>}</Button>} */}
          {(this.state.isEdit || this.props.isPopup) && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                variant="danger"
                onClick={this.cancelForm.bind(this)}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
              >
                انصراف
              </Button>
              <div style={{ width: "10px" }} />
              <Button
                variant={this.state.isEdit ? "primary" : "secondary"}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
                disabled={this.state.buttonDisabled}
                onClick={this.SubmitFrom.bind(this)}
              >
                {this.state.buttonDisabled && (
                  <Spinner className="spinnerStyle" animation="border" />
                )}
                {!this.state.buttonDisabled && this.state.isEdit && (
                  <div>ویرایش</div>
                )}
                {!this.state.buttonDisabled && !this.state.isEdit && (
                  <div>ثبت&nbsp;{this.state.buttonTitle}</div>
                )}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
